/**
 * Errores de dominio de purchases. `name` se setea explícito (la minificación
 * renombra clases en prod — VUELTO-NEGOCIO-34) y `code` preserva el código
 * interno para Sentry (regla error-mapping). Los nombres terminados en
 * `ValidationError` / listados en `EXPECTED_ERROR_NAMES` son filtrados por
 * `isExpectedBusinessError` y no llegan a Sentry.
 */
export class PurchaseDomainError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = 'PurchaseDomainError';
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/** Validación de negocio esperada (guard de invariante, motivo inválido, estado incorrecto). */
export class PurchaseValidationError extends PurchaseDomainError {
  constructor(message: string) {
    super('PURCHASE_VALIDATION', message);
    this.name = 'PurchaseValidationError';
  }
}

/** La entidad ya no existe / estado stale en la UI (ej. anulada en otro dispositivo). */
export class PurchaseNotFoundError extends PurchaseDomainError {
  constructor(message: string) {
    super('PURCHASE_NOT_FOUND', message);
    this.name = 'PurchaseNotFoundError';
  }
}
